import React, { useState } from 'react';
import { Chip, ToggleRow } from './ui';
import { SENSITIVE_CHIP } from '../../../utils/portalPageModel';

/**
 * One chip group — STRENGTHS · COUNT ON ME FOR · DOWN FOR.
 *
 * The vocabulary comes in as `chips` (from `utils/portalPageModel`); anything already picked that
 * is no longer in the list renders after it, still selected, so it can be removed. `max` dims and
 * disables the unpicked chips at the cap. "Write your own…" adds a chip the vocabulary doesn't
 * have — the Portal Editor needs it as much as onboarding does, or a custom pick made during
 * onboarding could never be replaced.
 *
 * `sensual` (when present) draws the SENSUAL & INTIMATE visibility toggle the moment that chip is
 * picked — the one answer in these groups that is a privacy setting rather than a tag.
 */
export default function ChipGroupField({
  picked, chips, onToggle, max, bg = '#fff', fg = '#000', allowCustom = true, sensual,
}) {
  const [draft, setDraft] = useState('');
  const extra = picked.filter((x) => !chips.includes(x));
  const full = max ? picked.length >= max : false;

  const add = () => {
    const v = draft.trim();
    setDraft('');
    if (!v || picked.includes(v) || full) return;
    onToggle(v);
  };

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {[...chips, ...extra].map((label) => {
          const sel = picked.includes(label);
          return <Chip key={label} selected={sel} disabled={full && !sel} onClick={() => onToggle(label)} bg={bg} fg={fg}>{label}</Chip>;
        })}
      </div>

      {sensual && picked.includes(SENSITIVE_CHIP) && (
        <ToggleRow
          on={sensual.on}
          onToggle={sensual.onToggle}
          label="Show Sensual and Intimate on my page"
          style={{ padding: '12px 14px', borderRadius: 18, background: '#000' }}
        >
          Show SENSUAL &amp; INTIMATE on my page. Off = only hosts you apply to see it.
        </ToggleRow>
      )}

      {allowCustom && (
        <span className="pe-in-wrap" style={{ display: 'flex', alignItems: 'center', gap: 8, height: 42, padding: '0 6px 0 18px', borderRadius: 999, background: '#000', boxShadow: 'inset 0 0 0 1px #2A2A2A', boxSizing: 'border-box' }}>
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
            placeholder="Write your own…"
            maxLength={40}
            aria-label="Write your own"
            style={{ flex: 1, minWidth: 0, height: '100%', border: 'none', background: 'none', boxShadow: 'none', outline: 'none', fontFamily: 'inherit', fontSize: 12, color: '#fff' }}
          />
          <button type="button" onClick={add} className="pk-btn" style={{ flexShrink: 0, height: 32, padding: '0 14px', background: '#1F1F1F', color: '#fff', fontSize: 10, fontWeight: 800, letterSpacing: '.14em' }}>+ ADD</button>
        </span>
      )}
    </>
  );
}
